import { Helmet } from "react-helmet";
import { useForm } from "react-hook-form";
// import API from "../../Api";
// import Swal from "sweetalert2";
import classes from "./Contact.module.css";
import mainclasses from "../style.module.css";

const Contact = () => {
  // const Toast = Swal.mixin({
  //     toast: true,
  //     showConfirmButton: false,
  //     timer: 3000,
  //     timerProgressBar: false,

  // });
  const {
    register,
    reset,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const onSubmit = (data, event) => {
    event.preventDefault();
    reset();
    // API.post(`contact`, data)
    //     .then(res => {
    //         Toast.fire({
    //             icon: 'success',
    //             title: res.data.message
    //         });
    //     }).catch(err => {
    //         console.log(err)
    //     });
  };
  return (
    <>
      <Helmet>
        <title>Contact | Sapid Books</title>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta name="description" content="Fill the form to contact us." />
      </Helmet>
      <div className="container-fluid mt-5">
        <div className="row">
          <div className="col-md-8 mx-auto text-center">
            <h2 className={mainclasses.heading}>Get In Touch With Us</h2>
            <img
              src={process.env.PUBLIC_URL + "/images/border.png"}
              alt="" id="b-img" style={{ width: "38%" }}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-10 mx-auto">
            <div className="row">
              <div className="col-lg-6 ml-lg-auto">
                <div className="single-item text-center p-3">
                  <div className="features-content">
                    <h3 className="title">India</h3>
                    <b>Head Office(Postal Address)</b>
                    <p>
                      16th Floor, Building no 5, Tower B, DLF Cyber City,
                      <br />
                      Phase-III, Gurugram-122002, Haryana, India
                    </p>
                  </div>
                </div>
                <div className="row">
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3506.6605179109806!2d77.0897089750285!3d28.489768690550335!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d192bb69840f5%3A0x7adc0cebaefc7fb8!2sSummit%20Online%20Trade%20Solutions%20Pvt.%20Ltd.!5e0!3m2!1sen!2sin!4v1693209144651!5m2!1sen!2sin"
                    title="Sugal & Damani"
                    width="600"
                    height="350"
                    loading="lazy"
                    allowFullScreen=""
                    referrerPolicy="no-referrer-when-downgrade"
                  ></iframe>
                </div>
              </div>
              <div className="col-lg-1"></div>
              <div className="col-lg-5 mt-4 shadow p-4">
                <form action=" " onSubmit={handleSubmit(onSubmit)}>
                  <div className={`mb-3  ${classes.inptcontdiv}`}>
                    <i className="fa fa-user-o" />
                    <input
                      type="text"
                      className={`form-control  ${classes.inptcont}`}
                      placeholder="Full Name *"
                      maxLength="50"
                      {...register("username", {
                        required: true,
                        pattern: /^[A-Za-z ]+$/i,
                      })}
                      name="username"
                      id="username"
                      autoComplete="off"
                    />
                    {errors.username && (
                      <p className={classes.error_p}>
                        Please enter a valid name.
                      </p>
                    )}
                  </div>
                  <div className={`mb-3  ${classes.inptcontdiv}`}>
                    <i className="fa fa-phone" />
                    <input
                      type="text"
                      className={`form-control  ${classes.inptcont}`}
                      placeholder="Contact No *"
                      name="mobile"
                      id="mobile"
                      maxLength="10"
                      {...register("mobile", {
                        required: true,
                        maxLength: 10,
                        minLength: 10,
                        pattern: /^[0-9\b]+$/,
                      })}
                      autoComplete="off"
                    />
                    {errors.mobile && (
                      <p className={classes.error_p}>
                        Enter a valid Mobile number.
                      </p>
                    )}
                  </div>
                  <div className={`mb-3  ${classes.inptcontdiv}`}>
                    <i className="fa fa-envelope-o" />
                    <input
                      type="email"
                      className={`form-control  ${classes.inptcont}`}
                      placeholder="Email"
                      name="email"
                      id="email"
                      {...register("email", { required: true })}
                      autoComplete="off"
                    />
                  </div>
                  {errors.email && (
                    <p className={classes.error_p}>Email is required.</p>
                  )}
                  <div className={`mb-3  ${classes.inptcontdiv}`}>
                    <i className="fa fa-commenting-o" />
                    <textarea
                      className={`form-control  ${classes.inptconttextarea}`}
                      placeholder="Message *"
                      {...register("message", { required: true })}
                      rows="4"
                      minLength="10"
                      maxLength="250"
                      id="message"
                      name="message"
                    />
                    {errors.message && (
                      <p className={classes.error_p}>Message is required.</p>
                    )}
                  </div>
                  <button type="submit" className={`btn ${classes.btncont}`}>
                    Submit
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Contact;
